<script setup>
import {
  Chart as ChartJS,
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend,
} from 'chart.js';
import { Radar } from 'vue-chartjs';
import * as chartConfig from '../stores/chartData';

ChartJS.defaults.color = '#fff';

ChartJS.register(
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend
);
</script>

<template>
  <div class="experience">
    <div class="experience__block">
      <h3>Intro 👋</h3>
      <p>
        I am a senior ecommerce/frontend specialist with Shopify depth. I have
        10+ years of agency experience in web devlopment working out of New
        Zealand.
      </p>
      <p>
        I'm a social programmer at heart, I love sharing my knowledge. I find it
        easy to adapt on my feet and thrive most when confronted with challenges
        that allow me to rise to the occasion.
      </p>
    </div>
    <div class="experience__block">
      <h3>Experience 👨‍✈️</h3>
      <p>
        At Pocket Square Ltd I held a title of Technical Leader and would often
        champion change within the company. On multiple occasions I built
        frameworks, DevOps and best practises for our team to use.
      </p>
      <p>
        Leading projects from start to finish has allowed me to think
        holistically and to prioritise key stakeholder requirements.
      </p>
    </div>
    <div class="two-columns">
      <div class="experience__block">
        <h3>Skills 💪</h3>
        <p>
          I take pride in inter departmental communication, documentation and
          scoping.
        </p>
        <p>Below are my hard skills visualised:</p>
        <Radar :data="chartConfig.data" :options="chartConfig.options" />
        <p>
          I lean heavily towards frontend technologies but did start out as a
          backend developer which allows me to collaborate confidently accross
          the stack.
        </p>
        <p>
          I specialize in Shopify, JavaScript, Vue 3, DevOps/Tooling,
          communication and planning.
        </p>
        <p>
          I am interested in roles which would allow me to reach expert level in
          areas like TypeScript, React and Python.
        </p>
      </div>
      <div class="experience__block">
        <h3>Achievements 🚀</h3>
        <ul class="ul">
          <li class="li">
            <p>
              Strategised the data architecture and built out a front facing
              <strong>Monogramming</strong> feature for
              <strong>The Daily Edited</strong>. The monogram featured 10+ fonts
              with highly nuanced customisation options.
            </p>
          </li>
          <li class="li">
            <p>
              Custom <strong>Wishlist</strong> pages for several clients
              allowing the creation of moodboards and the ability to share
              wishlists through email.
            </p>
          </li>
          <li class="li">
            <p>
              A front facing <strong>Subscription</strong> page for apparel
              compnay <strong>Asuwere</strong> on a cusom Recharge API proxy
              which allows customers to make account updates and modify their
              clothing selections for upcoming orders.
            </p>
          </li>
          <li class="li">
            <p>
              Built a <strong>Pick N Mix</strong> page for the jeweller
              <strong>Boh Runga</strong>, which allows customers to create their
              own pieces by mixing and matching between metals and charms and
              generating a preview and purchase link.
            </p>
          </li>
          <li class="li">
            <p>
              Sole developer of many <strong>Vue</strong> hybrid headless and
              elegant Shopify storefronts including <strong>Superette</strong>,
              <strong>Shine On</strong>, <strong>Status Anxiety</strong> and
              many more with an emphasis on performance, scalability, modern GQL
              API usage and developer friendly workflows.
            </p>
          </li>
          <li class="li">
            <p>
              Many more features across a wide range of clients including
              <strong>Walker & Hall</strong>, <strong>Life Pharmacy</strong>,
              <strong>Betts</strong>, <strong>The Horse</strong>,
              <strong>Bendon</strong>, <strong>JanSport</strong>.
            </p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.experience {
  &__block {
    margin-block: 2rem;
  }

  p {
    font-family: monospace;
    color: var(--white);
  }
}
</style>
